<template>
    <header>
        <!-- @todo Martin!! //-->
        <button class="btn-icon btn-replay-music">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 88 105"><path d="M40.3077 90.8878 23 89.4876V68.4852l17.3077-2.1003S54.8462 47.4827 59 50.283v53.206c0 7.001-18.6923-12.6012-18.6923-12.6012Z"/><path fill="#fff" fill-rule="evenodd" d="M63.5268 57.6346c.2018-1.3659 1.4726-2.3096 2.8385-2.1078 3.5079.5183 8.6892 2.1995 13.0545 5.6304C83.8611 64.6479 87.5 70.0044 87.5 77.6491c0 7.6345-3.6281 13.0922-8.0365 16.7199-4.3436 3.5743-9.5067 5.4425-13.0095 6.089-1.3578.251-2.6617-.6463-2.9125-2.004-.2507-1.3578.6467-2.6617 2.0044-2.9125 2.8305-.5227 7.1674-2.0931 10.7405-5.0334 3.5083-2.8869 6.2136-7.0198 6.2136-12.859 0-5.8291-2.6945-9.8292-6.1699-12.5608-3.5514-2.7912-7.8701-4.1978-10.6955-4.6152-1.3659-.2018-2.3096-1.4726-2.1078-2.8385Zm1.6433 11.8814c.6161-1.2356 2.1172-1.7379 3.3528-1.1218 2.2448 1.1193 7.0141 3.6502 7.0141 9.2549 0 2.6925-1.129 4.9393-2.5238 6.5938-1.3781 1.6347-3.1234 2.8268-4.6796 3.4476-1.2824.5115-2.7368-.1134-3.2483-1.3959-.5116-1.2824.1134-2.7367 1.3958-3.2483.7895-.3149 1.859-1.0175 2.7093-2.0261.8336-.9888 1.3466-2.1338 1.3466-3.3711 0-2.255-1.7987-3.5604-4.2452-4.7802-1.2356-.6162-1.7378-2.1173-1.1217-3.3529ZM40.3518 31.6858c11.5327-5.1637 24.7365 2.0735 24.7365 2.0735l4.1102-9.0835s-20.111-6.7149-33.139-.5442c-13.028 6.1707-18.798 18.4283-18.798 18.4283s-4.4406-4.9398-5.7697-5.5497c-1.3291-.6098-2.44439-.1721-2.80076 5.3443-.35361 5.5125 1.31846 15.133 3.41896 15.3278 2.8957.2718 6.4481-.7263 14.1652-3.4367 3.6511-1.2808 5.3642-3.2466 2.3555-4.8765-3.0088-1.6299-5.558-2.7379-5.558-2.7379s5.7464-9.7817 17.2791-14.9454Z"/></svg>
            <span class="sr-only">Rejouer musique</span>
        </button>
        <!-- @todo //-->

        <router-link :to="{name: 'extras', params:{ lang }}" class="btn-icon btn-extras">
            <SvgNote double></SvgNote>
            <span class="sr-only">Extras</span>
            <span class="button-text">{{score}}</span>
        </router-link>
        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>

    <speech-bubble>
        <template #default>
            <div class="content-text hidden">
                <div class="inner">
                    <p>Octave aime la musique, car elle lui fait ressentir toutes sortes d’émotions. Toi, comment te sens-tu lorsque tu entends cette musique?</p>
                </div>
            </div>

            <div class="content-choice hidden">
                <button class="choice">
                    <img class="thumbnail" src="/images/squirrel-joy.png" alt="Écureuil joyeux" />
                    Joie
                </button>
                <button class="choice">
                    <img class="thumbnail" src="/images/squirrel-fear.png" alt="Écureuil effrayé" />
                    Peur
                </button>
                <button class="choice">
                    <img class="thumbnail" src="/images/squirrel-sadness.png" alt="Écureuil triste" />
                    Tristesse
                </button>
                <button class="choice">
                    <img class="thumbnail" src="/images/squirrel-calm.png" alt="Écureuil calme" />
                    Calme
                </button>
            </div>

            <div class="content-feedback">
                <img class="thumbnail" src="/images/squirrel-sadness.png" alt="Écureuil triste" />
                <div class="inner">
                    <p>Cette musique te semble <strong>triste</strong>? </p>
                    <p>Moi, je me sens très <strong>calme</strong> quand j’écoute ce morceau.</p>
                </div>
                <!-- @todo Martin!! //-->
                <button class="btn-icon btn-replay-music">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 88 105"><path d="M40.3077 90.8878 23 89.4876V68.4852l17.3077-2.1003S54.8462 47.4827 59 50.283v53.206c0 7.001-18.6923-12.6012-18.6923-12.6012Z"/><path fill="#fff" fill-rule="evenodd" d="M63.5268 57.6346c.2018-1.3659 1.4726-2.3096 2.8385-2.1078 3.5079.5183 8.6892 2.1995 13.0545 5.6304C83.8611 64.6479 87.5 70.0044 87.5 77.6491c0 7.6345-3.6281 13.0922-8.0365 16.7199-4.3436 3.5743-9.5067 5.4425-13.0095 6.089-1.3578.251-2.6617-.6463-2.9125-2.004-.2507-1.3578.6467-2.6617 2.0044-2.9125 2.8305-.5227 7.1674-2.0931 10.7405-5.0334 3.5083-2.8869 6.2136-7.0198 6.2136-12.859 0-5.8291-2.6945-9.8292-6.1699-12.5608-3.5514-2.7912-7.8701-4.1978-10.6955-4.6152-1.3659-.2018-2.3096-1.4726-2.1078-2.8385Zm1.6433 11.8814c.6161-1.2356 2.1172-1.7379 3.3528-1.1218 2.2448 1.1193 7.0141 3.6502 7.0141 9.2549 0 2.6925-1.129 4.9393-2.5238 6.5938-1.3781 1.6347-3.1234 2.8268-4.6796 3.4476-1.2824.5115-2.7368-.1134-3.2483-1.3959-.5116-1.2824.1134-2.7367 1.3958-3.2483.7895-.3149 1.859-1.0175 2.7093-2.0261.8336-.9888 1.3466-2.1338 1.3466-3.3711 0-2.255-1.7987-3.5604-4.2452-4.7802-1.2356-.6162-1.7378-2.1173-1.1217-3.3529ZM40.3518 31.6858c11.5327-5.1637 24.7365 2.0735 24.7365 2.0735l4.1102-9.0835s-20.111-6.7149-33.139-.5442c-13.028 6.1707-18.798 18.4283-18.798 18.4283s-4.4406-4.9398-5.7697-5.5497c-1.3291-.6098-2.44439-.1721-2.80076 5.3443-.35361 5.5125 1.31846 15.133 3.41896 15.3278 2.8957.2718 6.4481-.7263 14.1652-3.4367 3.6511-1.2808 5.3642-3.2466 2.3555-4.8765-3.0088-1.6299-5.558-2.7379-5.558-2.7379s5.7464-9.7817 17.2791-14.9454Z"/></svg>
                    <span class="sr-only">Rejouer musique</span>
                </button>
                <!-- @todo //-->
            </div>
        </template>
    </speech-bubble>

    <!--<Notes :onClick="increaseScore" />//-->

    <!-- @todo Martin: ending for game1 //-->
    <nav role="navigation" class="big-buttons">
        <button class="btn-image">
            <h2 class="btn-image-title">Refaire l'exercice</h2>
            <img :src="`/images/btn-playagain-game1.jpg`" width="348" height="398" alt="" />
        </button>
        <button class="btn-image">
            <h2 class="btn-image-title">Refaire avec un ami mystère</h2>
            <img :src="`/images/btn-playagain-game1-mysteryfriend.jpg`" width="348" height="398" alt="" />
        </button>
        <button class="btn-image">
            <h2 class="btn-image-title">Refaire avec un décor mystère</h2>
            <img :src="`/images/btn-playagain-game1-mysterydecor.jpg`" width="348" height="398" alt="" />
        </button>
    </nav>

    <nav class="nav-prevnext">
        <router-link :to="previousPage" class="btn-icon btn-prev" v-if="currentLevel == 1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
        </router-link>

        <button @click="tempPrevPage" class="btn-icon btn-prev" v-else>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
        </button>

        <button @click="nextPage" class="btn-icon btn-next">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 66 52"><path fill-rule="evenodd" d="M2.73 14.54c-1.86.44-3.28 2.89-2.52 9C.97 29.65.16 34.78.7 36.69c.55 1.91 1.07 3.63 12.26 1.18s19.96-4.95 19.96-4.95-3.11 13.5-2.56 16.5c.55 3 2.63 4.38 12.46-1.62 9.82-6 24.22-20.38 22.04-24.2-3-5.27-8.95-10.14-22.8-20.07-6.55-4.7-11.95-5.27-11.13 1.82.82 7.09 1.98 12.77 1.98 12.77S8.62 13.15 2.74 14.55l-.01-.01Z" clip-rule="evenodd"/></svg>
        </button>
    </nav>

</template>

<script>
    import SpeechBubble from "../components/SpeechBubble";
    import SvgNote from "../components/SvgNote";
    import Notes from "../components/Notes";

    export default {
        name: "Game1",
        components: { SpeechBubble, SvgNote, Notes }
    }
</script>

<script setup>
    import { computed, ref } from "vue";

    import { useMainStore }     from "../stores/main";
    import { storeToRefs }      from "pinia";

    let store = useMainStore();
    const { lang, score } = storeToRefs(store);

    const { getPreviousPage } = store;
    let previousPage = computed ( () => getPreviousPage());

    let currentLevel = ref (1);

    function tempPrevPage ()
    {
        // return {name: 'play', params: { lang: lang.value, id: 1 }};

        //THIS IS SOME TEMP CODE FOR MJ TO TEST SCENE
        currentLevel.value --;
        document.dispatchEvent(new CustomEvent("route-change", {detail: {scene: "foret-" + currentLevel.value}}));
    }

    function nextPage ()
    {
       // return {name: 'play', params: { lang: lang.value, id: 1 }};

        //THIS IS SOME TEMP CODE FOR MJ TO TEST SCENE
        currentLevel.value ++;
        document.dispatchEvent(new CustomEvent("route-change", {detail: {scene: "foret-" + currentLevel.value}}));
    }

    function increaseScore() {
        score.value = score.value + 1;
    }

</script>
